import { WorkOrder } from "@eljouren/domain";
import { IpisFileV2 } from "@eljouren/file-schemas";
import {
  FilePermissions,
  SingleFilePermissions,
} from "../../types/file-permissions";

type Args =
  | {
      workOrder: WorkOrder.HandymanWithPermissionsType;
      as: "handyman";
    }
  | {
      as: "salesTeam";
      workOrder: WorkOrder.CustomerType;
    };

export function useAuthenticatedFilePermissions(props: Args): FilePermissions {
  const allowedToHandle =
    props.as === "salesTeam" || props.workOrder.allowedToHandleOrder;
  const canUpload = !props.workOrder.isFinished && allowedToHandle;

  function checkFilePermissions(file: IpisFileV2.Type): SingleFilePermissions {
    const relatedToWorkOrder = !!file.relations?.every(
      (rel) => rel.type === "workOrder"
    );
    const uploadedByHandymanOrCustomer =
      file.uploadedBy === "worker" || file.uploadedBy === "customer";

    const hasTag = !!file.tag;

    const canDeleteNonStaff =
      canUpload &&
      relatedToWorkOrder &&
      uploadedByHandymanOrCustomer &&
      !hasTag;

    const canDeleteStaff = props.as === "salesTeam" && canUpload && !hasTag;

    return {
      canDelete: canDeleteNonStaff || canDeleteStaff,
    };
  }

  return {
    canUpload,
    forFile: checkFilePermissions,
  };
}
